import * as React from 'react';

import { RadioItemLabelContext } from '@/hen-ui/atomics/Radio/radio-label-context';

import {
  PartnerStarRating,
  type PartnerStarRatingProps,
} from './PartnerStarRating';
import { RatingStar, type RatingStarProps } from './RatingStar';

export type RatingVariant = 'rating-star' | 'partner';

type PartnerRatingProps = PartnerStarRatingProps & {
  variant?: 'partner';
};

type RatingStarVariantProps = RatingStarProps & {
  variant: 'rating-star';
};

export type RatingProps = PartnerRatingProps | RatingStarVariantProps;

export const Rating: React.FC<RatingProps> = (props) => {
  const inRadioItemLabel = React.useContext(RadioItemLabelContext);
  const ratingProps = inRadioItemLabel
    ? { ...props, showRatingTooltip: false }
    : props;

  if (ratingProps.variant === 'rating-star') {
    return <RatingStar {...ratingProps} />;
  }

  return <PartnerStarRating {...ratingProps} />;
};

Rating.displayName = 'Rating';
